export const HOMESTAY_All_ACTION = "HOMESTAY_All_ACTION";
export const HOMESTAY_All_SUCCESS = "HOMESTAY_All_SUCCESS";
export const HOMESTAY_All_FAIL = "HOMESTAY_All_FAIL";

export const HOMESTAY_LIST_ACTION = "HOMESTAY_LIST_ACTION";
export const HOMESTAY_LIST_SUCCESS = "HOMESTAY_LIST_SUCCESS";
export const HOMESTAY_LIST_FAIL = "HOMESTAY_LIST_FAIL";

export const HOMESTAY_DETAIL_ACTION = "HOMESTAY_DETAIL_ACTION";
export const HOMESTAY_DETAIL_SUCCESS = "HOMESTAY_DETAIL_SUCCESS";
export const HOMESTAY_DETAIL_FAIL = "HOMESTAY_DETAIL_FAIL";

export const HOMESTAY_FAIL = "HOMESTAY_FAIL";
export const HOMESTAY_DETAIL_UPDATE_ACTION = "HOMESTAY_DETAIL_UPDATE_ACTION";
export const HOMESTAY_DETAIL_CREATE_ACTION = "HOMESTAY_DETAIL_CREATE_ACTION";

export const HOMESTAY_CREATE_TRANSLATE_ACTION = "HOMESTAY_CREATE_TRANSLATE_ACTION";
export const HOMESTAY_CREATE_TRANSLATE_SUCCESS = "HOMESTAY_CREATE_TRANSLATE_SUCCESS";

export const HOMESTAY_UPDATE_TRANSLATE_ACTION = "HOMESTAY_UPDATE_TRANSLATE_ACTION";
export const HOMESTAY_UPDATE_TRANSLATE_SUCCESS = "HOMESTAY_UPDATE_TRANSLATE_SUCCESS";

export const HOMESTAY_DELETE_TRANSLATE_ACTION = "HOMESTAY_DELETE_TRANSLATE_ACTION";
export const HOMESTAY_DELETE_TRANSLATE_SUCCESS = "HOMESTAY_DELETE_TRANSLATE_SUCCESS";

export const HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION = "HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTION";
export const HOMESTAY_TAG_GROUP_DETAIL_SKU_SUCCESS = "HOMESTAY_TAG_GROUP_DETAIL_SKU_SUCCESS";

export const HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION = "HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_ACTION";
export const HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS = "HOMESTAY_TAG_GROUP_DETAIL_SKU_ACTIVE_SUCCESS";

export const HOMESTAY_ALL_ACTIVE_ACTION = "HOMESTAY_ALL_ACTIVE_ACTION";
export const HOMESTAY_ALL_ACTIVE_SUCCESS = "HOMESTAY_ALL_ACTIVE_SUCCESS";
export const HOMESTAY_ALL_ACTIVE_FAIL = "HOMESTAY_ALL_ACTIVE_FAIL";

export const CLEAR_CACHE_ACTION = "CLEAR_CACHE_ACTION";
export const CLEAR_CACHE_SUCCESS = "CLEAR_CACHE_SUCCESS";

export const RATE_LIST_COMPARE_ACTION = "RATE_LIST_COMPARE_ACTION";
export const RATE_LIST_COMPARE_SUCCESS = "RATE_LIST_COMPARE_SUCCESS";
export const RATE_LIST_COMPARE_FAIL = "RATE_LIST_COMPARE_FAIL";
export const RATE_LIST_COMPARE_CREATE_ACTION = "RATE_LIST_COMPARE_CREATE_ACTION";
export const RATE_LIST_COMPARE_UPDATE_ACTION = "RATE_LIST_COMPARE_UPDATE_ACTION";
export const RATE_LIST_COMPARE_DELETE_ACTION = "RATE_LIST_COMPARE_DELETE_ACTION";
